<template>
    <div class="single-filter search-filter-dropdown">
        <div class="dropdown dropdown-with-animation" :class="{'disabled':data.disabled}">
            <div :id="inputFieldId"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="input-group"
            >
                <div class="input-group mb-3">
                    <div v-if="data.icon" class="input-group-prepend">
                        <span ref="iconContainer" class="input-group-text">
                            <i :data-feather="selectedValue || 'activity'"></i>
                        </span>
                    </div>
                    <input type="text"
                        class="form-control cursor-pointer"
                        :placeholder="data.placeholder"
                        :disabled="data.disabled"
                        @click="startNavigation"
                        @input="handleMainInput($event)"
                        :value="showValue">
                </div>
            </div>

            <div class="dropdown-menu py-0 my-1" :class="data.listClass" :aria-labelledby="inputFieldId">
                <div class="form-group form-group-with-search">
                    <span class="form-control-feedback">
                        <app-icon name="search"/>
                    </span>
                    <input type="text"
                        ref="searchInput"
                        :class="'form-control '+data.listItemInputClass"
                        :placeholder="$t('search')"
                        :value="searchValue"
                        @input="getSearchValue($event)"
                        @keydown.down="navigateDown"
                        @keydown.up="navigateUp"
                        @keydown.enter.prevent="enterSelectedValue"
                        :autofocus="startNavigation">
                </div>
                <div class="dropdown-divider my-0"/>
                <div class="dropdown-search-result-wrapper custom-scrollbar" ref="optionList">
                    <a class="dropdown-item"
                        href="#"
                        v-for="(item,index) in options"
                        :class="{'active': index === activeIndex, [data.listItemClass]: !isUndefined(data.listItemClass), 'selected': item.id === value, 'disabled': item.disabled}"
                        @click.prevent="changeSelectedValue(item)"
                        :key="`${inputFieldId}-${index}`">
                        <span v-html="item[data.listValueField]"></span>
                        <span class="check-sign float-right">
                            <app-icon name="check" class="menu-icon"/>
                        </span>
                    </a>
                    <div v-if="!options.length" class="text-center text-muted text-size-13 py-primary">
                        {{ hintText }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';
import {NavigationMixin} from "./mixin/NavigationMixin";
import CoreLibrary from "../../helpers/CoreLibrary";
import feather from 'feather-icons'

export default {
    name   : "SearchSelect",
    mixins : [InputMixin, NavigationMixin],
    extends: CoreLibrary,
    data() {
        return {
            selectedValue: '',
            searchValue  : '',
            isCustomEntry: false,
        }
    },
    watch   : {
        selectedValue: {
            handler(value) {
                if (this.data.icon) {
                    const el     = this.$refs.iconContainer
                    el.innerHTML = `<i data-feather="${this.selectedValue || 'activity'}"></i>`
                    feather.replace()
                }
            },
        },
        value: {
            immediate: true,
            handler(value) {
                if (this.isCustomEntry && value === this.selectedValue) {
                    return;
                }
                this.selectedValue = value;
                this.isCustomEntry = false;
            }
        }
    },
    computed: {
        options() {
            this.activeIndex = -1;
            if (!_.isEmpty(this.searchValue)) {
                return this.data.list.filter(item => {
                    return item[this.data.listValueField].toLowerCase().includes(this.searchValue.toLowerCase());
                });
            } else return this.data.list;
        },
        allowCustomValue() {
            return Boolean(this.data.allowCustomValue);
        },
        showValue() {
            if (this.allowCustomValue && this.isCustomEntry) {
                return this.value || '';
            }
            const list = Array.isArray(this.data.list) ? this.data.list : [];
            const matchedItem = list.find(item => `${item.id}` === `${this.value}`);
            if (matchedItem) {
                return matchedItem[this.data.listValueField].replace(/<[^>]+>/g, '');
            }
            return this.allowCustomValue ? (this.value || '') : '';
        },
        hintText() {
            return !this.data.list.length ? this.$t('no_options_found') : (!this.options.length ? this.$t('did_not_match_anything') : '');
        }
    },
    methods : {
        getSearchValue($event) {
            this.searchValue = $event.target.value;
        },
        changed() {
            this.$emit('input', this.selectedValue);
        },
        changeSelectedValue(value) {
            this.isCustomEntry   = false;
            this.selectedValue   = value.id;
            this.searchValue     = "";
            this.navigationStart = false;
            this.changed();
            this.$hub.$emit(this.inputFieldId + '.selected', value);
        },
        enterSelectedValue() {
            const selectedOption = this.options[this.activeIndex];
            if (selectedOption) {
                this.changeSelectedValue(selectedOption);
            }
            this.endNavigation();
        },
        applyCustomValue(value, {keepSearchValue = false, skipNavigationReset = false} = {}) {
            if (!this.allowCustomValue) {
                return;
            }
            const trimmedValue = (value || '').trim();
            if (!trimmedValue) {
                this.clear();
                return;
            }
            this.selectedValue   = trimmedValue;
            if (!keepSearchValue) {
                this.searchValue = trimmedValue;
            }
            if (!skipNavigationReset) {
                this.navigationStart = false;
            }
            this.changed();
            this.$hub.$emit(this.inputFieldId + '.input', trimmedValue);
        },
        handleMainInput(event) {
            if (!this.allowCustomValue) {
                event.preventDefault();
                this.startNavigation();
                return;
            }
            const value = event.target.value || '';
            this.isCustomEntry = Boolean(value.trim());
            this.applyCustomValue(value, {keepSearchValue: true, skipNavigationReset: true});
        },
        clear() {
            this.isCustomEntry = false;
            this.selectedValue = '';
            this.searchValue   = '';
            this.changed();
        }
    }
}
</script>
